"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toOptional = exports.toBoolean = exports.toNumber = exports.toString = exports.isObject = exports.isBoolean = exports.isNumber = exports.isString = exports.isFalsy = exports.noExist = exports.nonEmpty = exports.isTruthy = exports.isExist = exports.isEmpty = void 0;
/**
 * return true when match following condition
 *  1. is undefined or null
 *  2. is empty string
 *  3. is empty object ({})
 *  4. is empty array ([])
 *
 * @param t input on any data type
 */
var isEmpty = function (t) {
    if (exports.noExist(t))
        return true;
    if (exports.isObject(t) && exports.isEmpty(Object.keys(t)))
        return true;
    else if (Array.isArray(t) && t.length <= 0)
        return true;
    else if (typeof t === "string" && t === "")
        return true;
    return false;
};
exports.isEmpty = isEmpty;
var isExist = function (t) {
    return t !== undefined && t !== null;
};
exports.isExist = isExist;
var isTruthy = function (t) {
    if (t)
        return true;
    else
        return false;
};
exports.isTruthy = isTruthy;
/**
 * The reverse function of isEmpty
 *
 * @param t input on any data type
 */
var nonEmpty = function (t) {
    return !exports.isEmpty(t);
};
exports.nonEmpty = nonEmpty;
var noExist = function (t) {
    return t === undefined || t === null;
};
exports.noExist = noExist;
var isFalsy = function (t) {
    if (t)
        return false;
    else
        return true;
};
exports.isFalsy = isFalsy;
var isString = function (t) {
    return exports.isExist(t) && typeof t === "string";
};
exports.isString = isString;
var isNumber = function (t, ignoreSpecial) {
    if (ignoreSpecial === void 0) { ignoreSpecial = false; }
    if (exports.isExist(t)) {
        if (typeof t === "number") {
            if (ignoreSpecial)
                return true;
            else
                return !isNaN(t) && isFinite(t);
        }
    }
    return false;
};
exports.isNumber = isNumber;
var isBoolean = function (t) {
    return exports.isExist(t) && typeof t === "boolean";
};
exports.isBoolean = isBoolean;
/**
 * checking is input is object datatype (object mean typeof input will return object)
 *
 * @param obj input of any type
 */
var isObject = function (obj) {
    if (obj === undefined || obj === null)
        return false;
    else
        return typeof obj === "object" && !Array.isArray(obj);
};
exports.isObject = isObject;
/**
 * Cast input to string. This supporting by listed below
 *
 * 1. undefined | null => return undefined
 * 2. boolean | string => return as string
 * 3. number           => return as fix digit not more than 6
 * 4. array            => return as array syntax without space
 * 5. object           => return by JSON.stringify()
 *
 * @param input input data on any type
 */
var toString = function (input) {
    if (exports.noExist(input))
        return undefined;
    else if (exports.isString(input))
        return input;
    else if (exports.isBoolean(input))
        return input ? "true" : "false";
    else if (exports.isNumber(input))
        return input.toString(10);
    else if (Array.isArray(input))
        return "[" + input.join(",") + "]";
    else if (exports.isObject(input))
        return JSON.stringify(input);
    else
        return undefined;
};
exports.toString = toString;
/**
 * Cast input to number, This supported by list below
 *
 * 1. undefined | null  => return undefined
 * 2. boolean           => return 1 if true; otherwise, return 0
 * 3. string            => return by converter function
 *
 * @param input input data on any type
 * @param converter parseFloat or parseInt, applied only when input is string. (default is parseFloat())
 */
var toNumber = function (input, converter) {
    if (converter === void 0) { converter = parseFloat; }
    if (exports.noExist(input))
        return undefined;
    else if (exports.isNumber(input))
        return input;
    else if (exports.isBoolean(input))
        return input ? 1 : 0;
    else if (exports.isString(input)) {
        var n = converter(input);
        return isFinite(n) ? n : undefined;
    }
    else
        return undefined;
};
exports.toNumber = toNumber;
var toBoolean = function (input) {
    if (exports.noExist(input))
        return undefined;
    else if (exports.isBoolean(input))
        return input;
    else if (exports.isNumber(input)) {
        var isTrue = input === 1;
        var isFalse = input === 0;
        if (isTrue)
            return true;
        else if (isFalse)
            return false;
        else
            return undefined;
    }
    else if (exports.isString(input)) {
        var isTrue = input === "true" || input === "1";
        var isFalse = input === "false" || input === "0";
        if (isTrue)
            return true;
        else if (isFalse)
            return false;
        else
            return undefined;
    }
    else
        return undefined;
};
exports.toBoolean = toBoolean;
/**
 * remove null possiblity and return as undefined instead
 *
 * @param input input as any type and undefined | null
 * @return input if input is exist; otherwise, return undefined. This function will never return null
 */
var toOptional = function (input) {
    return exports.isExist(input) ? input : undefined;
};
exports.toOptional = toOptional;
//# sourceMappingURL=generic.js.map